export enum JuconnUserRoleEnum {
    super_admin = 'super_admin',
    user_planner = 'user_planner',
    user_service_technician = 'user_service_technician',
    customer_admin = 'customer_admin',
    customer_user = 'customer_user'
}
